/**
 * Čista logika podešavanja restorana (bez Vue-a i bez prevoda): rokovi po danima, sedmični ciklus i provjere unosa.
 * Računanje dometa je isto kao checkDisabled() u src/utils/menuUtils.js: prije roka važi day_before_limit, poslije
 * roka day_after_limit, a posljednji dan koji se može naručiti je danas + taj broj dana (rok je strogo "prije").
 * Dani su brojevi 0–6 (ponedjeljak–nedjelja), vrijeme je "HH:MM".
 */
export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const MAX_DAYS = 60;
export const MAX_ORDER_AHEAD = 15;
export const MAX_CANCEL_MINUTES = 1440;
export const MAX_TIMER = 60;

/** Minute od ponoći; null kad vrijeme nije potpuno ("", "9", "09:"). */
export const toMin = (hhmm) => {
  const parts = String(hhmm == null ? "" : hhmm).split(":");
  if (parts.length < 2 || parts[0] === "" || parts[1] === "") {
    return null;
  }
  const h = Number(parts[0]);
  const m = Number(parts[1]);
  return Number.isNaN(h) || Number.isNaN(m) ? null : h * 60 + m;
};

/** Broj iz unosa; prazno i neispravno je 0 (tako ga računa i checkDisabled). */
export const num = (v) => {
  const n = Number(v);
  return v === "" || v == null || Number.isNaN(n) ? 0 : n;
};

/**
 * Sedmični ciklus: prozor naručivanja se završava u horizonDay, a nova sedmica se otvara u openDay u openTime.
 * Vraća 7 pravila (ponedjeljak–nedjelja) oblika { before, after, time }.
 */
export const cycleRules = (horizonDay, openDay, openTime) => {
  const nextHorizon = (w) => (horizonDay - w + 7) % 7 || 7;
  const base = nextHorizon(openDay) + 7;
  const rules = [];
  for (let w = 0; w < 7; w++) {
    const k = (w - openDay + 7) % 7;
    const after = base - k;
    rules.push({ before: k === 0 ? after - 7 : after, after, time: openTime });
  }
  return rules;
};

/** Prepoznaje da li pravila odgovaraju nekom sedmičnom ciklusu; vraća { h, o, time } ili null. */
export const detectCycle = (rules) => {
  for (let h = 0; h < 7; h++) {
    for (let o = 0; o < 7; o++) {
      const time = rules[o] && rules[o].time;
      if (!time) {
        continue;
      }
      const cycle = cycleRules(h, o, time);
      let ok = true;
      for (let w = 0; w < 7 && ok; w++) {
        ok =
          num(rules[w].before) === cycle[w].before &&
          num(rules[w].after) === cycle[w].after &&
          rules[w].time === time &&
          String(rules[w].before) !== "" &&
          String(rules[w].after) !== "";
      }
      if (ok) {
        return { h, o, time };
      }
    }
  }
  return null;
};

/** Isti rok i isti broj dana za svih sedam dana. */
export const isUniform = (rules) => {
  for (let w = 1; w < 7; w++) {
    if (
      String(rules[w].before) !== String(rules[0].before) ||
      String(rules[w].after) !== String(rules[0].after) ||
      rules[w].time !== rules[0].time
    ) {
      return false;
    }
  }
  return String(rules[0].time || "") !== "" && String(rules[0].before) !== "" && String(rules[0].after) !== "";
};

// ---------------------------------------------------------------- provjere unosa
/** Cijeli broj dana od 0 do 60 (prazno se ovdje ne smatra ispravnim; prazno rješava pozivalac). */
export const okDays = (v) => /^\d{1,2}$/.test(String(v).trim()) && Number(v) <= MAX_DAYS;
export const okTime = (v) => /^\d{2}:\d{2}$/.test(String(v || ""));
export const okMoney = (v) => v === "" || v == null || /^\d+([.,]\d{1,2})?$/.test(String(v).trim());
export const okUrl = (v) => v === "" || v == null || /^https?:\/\/[^\s/.]+\.[^\s]{2,}$/i.test(String(v).trim());
export const okInt = (v, lo, hi) => /^\d{1,4}$/.test(String(v).trim()) && Number(v) >= lo && Number(v) <= hi;

export const isBlank = (v) => v === "" || v == null;
